export const getFilterLocations = () => {
  const categoryStr = process.env.REACT_APP_FILTER_LOCATIONS ?? '[]'
  const jsonString = categoryStr?.replace(/'/g, '"')
  const result = JSON.parse(jsonString)
  return result
}

export const safelyParse = (data: string): any => {
  try {
    return JSON.parse(data)
  } catch (error) {
    console.error('Failed to parse WebSocket message:', error)
    return null
  }
}

export function generateRandomID(length: number): string {
  if (!length) return ''

  const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  const numbers = '0123456789'
  const characters = alphabets + numbers

  let result = ''

  result += alphabets.charAt(
    crypto.getRandomValues(new Uint8Array(1))[0] % alphabets.length
  )
  result += numbers.charAt(
    crypto.getRandomValues(new Uint8Array(1))[0] % numbers.length
  )

  for (let i = 2; i < length; i++) {
    result += characters.charAt(
      crypto.getRandomValues(new Uint8Array(1))[0] % characters.length
    )
  }

  return result
    ?.split('')
    ?.sort(() => 0.5 - crypto.getRandomValues(new Uint8Array(1))[0])
    ?.join('')
}

export const updateMessage = (
  categoryType: string | null,
  selectedDeviceId: string
) => {
  if (!categoryType) return `Device ${selectedDeviceId} Mapping created.`
  return `Device ${selectedDeviceId} mapping updated.`
}
